import React from 'react'

import type { FooterData } from '../../data'

import { cls } from 'tagged-classnames-free';
import Link from '@/components/Link';
export type FooterItemProps = FooterData['children'][number]

const FooterItem: React.FC<FooterItemProps> = (props) => {
  const { href, label, nofollow } = props

  const liClassName = cls`mt-3 break-inside-avoid whitespace-normal break-words hover:text-white`
  if (href) {
    return (
      <li className={liClassName}>
        <Link href={href} rel={nofollow ? 'nofollow noreferrer' : undefined}>
          {label}
        </Link>
      </li>
    )
  }
  return <li className={liClassName}>{label}</li>
}
export default FooterItem
